import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryScriptPromptUseAttributes } from './generated/DiscoveryScriptPromptUseAttributes';
import { model } from '../modelBuilder';

interface DiscoveryScriptPromptUse extends DiscoveryScriptPromptUseAttributes {}

@model
class DiscoveryScriptPromptUse extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryScriptPromptUse' = 'DiscoveryScriptPromptUse';
  get typename(): 'DiscoveryScriptPromptUse' {
    return 'DiscoveryScriptPromptUse';
  }

  static internalTypename: 'Discovery::ScriptPromptUse' =
    'Discovery::ScriptPromptUse';
  get internalTypename(): 'Discovery::ScriptPromptUse' {
    return 'Discovery::ScriptPromptUse';
  }

  static filterType = 'ScriptPromptUseFilters!';
  static filters = {
    id: '[ID!]',
    discoveryInterviewId: 'ID',
    discoveryScriptPromptId: 'ID',
    discoveryInterview: 'DiscoveryInterviewRelationshipInput',
    discoveryScriptPrompt: 'DiscoveryScriptPromptRelationshipInput',
  };

  static fields = {
    annotationsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    discoveryInterviewId: attr({ readable: true }),
    discoveryScriptPromptId: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    discoveryInterview: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryInterview',
    }),
    discoveryScriptPrompt: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryScriptPrompt',
    }),
    annotations: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default DiscoveryScriptPromptUse;
